export default __webpack_public_path__ + "static/media/testimonials.748f5714.png";